import { Component } from "utils";

const projectIcon = require('./templates/projectIcon.tpl.html');
const projectContext = require('./templates/projectActions.tpl.html');
const projectLink = require('./templates/projectLink.tpl.html');

@Component({
    controllerAs: 'vm',
    template: require('./projectsListData.tpl.html'),
    bindings: {
        data: '<',
        selectedUserFilterKey: '<',
    }
})
export class ProjectsListDataComponent {
    static $inject = ['$scope','$state', 'store', 'popUpModal', 'utils','openProject'];

    constructor($scope,$state, store, popUpModal, utils, openProject) {
        this.store = store;
        this.$scope = $scope;
        this.$state = $state;
        this.popUpModal = popUpModal;
        this.utils = utils;
        this.openProject = openProject;
        this.currentUserId = this.$state.$current.locals.globals.userDetails.data.id;
        this.$scope.openProject = this.goToProject.bind(this);
            this.gridOptions = {
            expandableRowHeight: 60,
            infiniteScrollRowsFromEnd: 20,
            infiniteScrollUp: false,
            infiniteScrollDown: true,
            enableInfiniteScroll: true,
            rowHeight: 35,
            columnDefs: [
                {
                displayName: 'Name',
                width: 200,
                minWidth: 200,
                enablePinning: true,
                enableHiding: false,
                name: 'modifiedName',
                cellTemplate: projectLink
            },
            {
                displayName: 'Last Deployed Version',
                width: 200,
                minWidth: 200,
                enablePinning: true,
                enableHiding: false,
                name: 'lastDeployedVersion',
            },
            {
                displayName: 'Last Available Version',
                width: 200,
                minWidth: 200,
                enablePinning: true,
                enableHiding: false,
                name: 'lastAvailableVersion'
            },
            {
                displayName: 'Last Activity',
                width: 120,
                minWidth: 100,
                enablePinning: true,
                enableHiding: false,
                name: 'lastActivity',
            },
            {
                displayName: 'DB Types',
                cellClass: 'center-grid-cell',
                width: 120,
                minWidth: 100,
                enablePinning: true,
                enableHiding: false,
                name: 'dbType',
                visible: true,
                cellTemplate: projectIcon
            },
            {
                displayName: 'Created By',
                width: 200,
                minWidth: 100,
                enablePinning: true,
                enableHiding: false,
                name: 'createdBy',
            },
            {
                displayName: 'Action',
                width: 100,
                cellClass: 'action-cell',
                minWidth: 100,
                enablePinning: true,
                enableHiding: false,
                name: 'action',
                cellTemplate: projectContext
            }
            ]
        };
        this.loadGrid();
    }

    loadGrid = () => {
        this.gridOptions.data = [];
        this.filteredData().map(data => {
            data.lastActivity = this.utils.convertUTCtoLocalString(data.lastActivity) || 'NA'
            this.gridOptions.data.push(data);
        });
    }

    filteredData() {
        return this.data.filter((item) => {
            if (this.selectedUserFilterKey === '0') {
                return true
            }
            return item.createdById === this.currentUserId
        })
    }

    get data() {
        return this._data;
    }

    set data(value) {
        this._data = angular.copy(value);
        if (this.gridOptions && value) {
            this.loadGrid();
        }
    }

    get selectedUserFilterKey() {
        return this._selectedUserFilterKey;
    }

    set selectedUserFilterKey(value) {
        this._selectedUserFilterKey = angular.copy(value);
        if (this.gridOptions && value) {
            this.loadGrid();
        }
    }

    goToProject =(id)=>
    {
        this.$scope.$broadcast(this.openProject,id);
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/projects/projects-list/projectsListData.js